<template>
    <div>
      发票
    </div>
  </template>

<script>
export default {

};
</script>

  <style>

  </style>
